import { ConditionsSheetsSelection } from '@src/common/components/ConditionsSheetsSelection';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { FormConditionSheet } from '@src/permits/completePermit/fields/ConditionSheets';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import { useFormContext } from 'react-hook-form';

export const ConditionsSheetsSection = ({
  conditionsSheets,
}: {
  conditionsSheets: FormConditionSheet[];
}) => {
  const { control } = useFormContext<AddPermitTypeFormInputs>();

  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <ConditionsSheetsSelection
        conditionsSheets={conditionsSheets}
        control={control}
      />
    </Stack>
  );
};
